import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from '@angular/core'
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { StoreService } from '../../service/store.service'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-company-structure-table',
  templateUrl: './company-structure-table.component.html',
  styleUrls: ['./company-structure-table.component.scss']
})
export class CompanyStructureTableComponent implements OnInit {
  @Input() printPage
  @Input() callEditFunctions: Map<String, Function>
  @Output() onFinished: EventEmitter<any> = new EventEmitter()
  @Output() flagChange: EventEmitter<any> = new EventEmitter()
  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('templateDel') templateDel: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  comstrucForm: FormGroup
  subscription: Subscription
  showData = false
  editFlag = false
  listTable = []
  listItem = []
  listDelete = []
  listAdd = []
  message
  symbol

  constructor(
    private fb: FormBuilder,
    private store: StoreService,
    private cpmService: CpmService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.createForm()

    const { symbol } = this.activatedRoute.snapshot.params

    if (symbol !== undefined) {
      this.cpmService.getCompanyStructure(symbol).subscribe(obj => {
        obj.length === 0 ? (this.showData = true) : (this.showData = false)
        this.listItem = []
        this.rebuildForm()
        obj.map(company => {
          this.listItem.push(company)
        })
        this.setUpForm(this.listItem)
      })
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.symbol = response['securitySymbol']
          this.cpmService.getCompanyStructure(this.symbol).subscribe(obj => {
            obj.length === 0 ? (this.showData = true) : (this.showData = false)
            this.listItem = []
            this.rebuildForm()
            obj.map(company => {
              this.listItem.push(company)
            })
            this.setUpForm(this.listItem)
          })
        })
    }
  }

  createForm() {
    this.comstrucForm = this.fb.group({
      // mode: new FormControl('I'),
      items: this.fb.array([])
    })
  }

  setUpForm(listItem) {
    listItem.map(item => {
      // this.comstrucForm.get('mode').setValue('U');
      const obj = new CompanyStructureObj()
      obj.id = item.id
      obj.companyName = [item.companyName, Validators.required]
      obj.businessType = [item.businessType]
      obj.percentShareholder = [
        item.percentShareholder,
        Validators.compose([Validators.max(100)])
      ]
      obj.percentOtherShareholder = 100 - item.percentShareholder
      this.items.push(this.fb.group(obj))
    })
  }

  setEdit() {
    // tslint:disable-next-line:no-unused-expression
    this.items.length === 0 ? this.addItem() : null
    this.editFlag = true
  }

  addItem() {
    const obj = new CompanyStructureObj()
    obj.id = ''
    obj.companyName = ['', Validators.required]
    obj.businessType = ['']
    obj.percentShareholder = ['', Validators.compose([Validators.max(100)])]
    obj.percentOtherShareholder = ''
    this.items.push(this.fb.group(obj))
  }

  get items(): FormArray {
    return this.comstrucForm.get('items') as FormArray
  }

  onDelete(index) {
    const idDelete = this.items.controls[index].get('id').value
    const tmp = idDelete === '' ? null : this.listDelete.push(idDelete)
    this.items.removeAt(index)
  }

  onCancel() {
    this.editFlag = false
    // this.toastr.info('Cancel action.')
    this.flagChange.emit(true)
    this.rebuildForm()
  }

  rebuildForm() {
    this.comstrucForm.reset({})
    this.setItems(this.listItem)
  }

  setItems(listItem) {
    const itemFGs = listItem.map(item =>
      this.fb.group({
        id: item.id,
        companyName: item.companyName,
        businessType: item.businessType,
        percentShareholder: item.percentShareholder,
        percentOtherShareholder: 100 - item.percentShareholder
      })
    )
    const itemFormArray = this.fb.array(itemFGs)
    this.comstrucForm.setControl('items', itemFormArray)
  }

  onSubmit() {
    this.listAdd = []
    if (this.comstrucForm.valid) {
      this.items.controls.filter(obj => obj.pristine === false).map(item => {
        const data = {
          id: item.value.id,
          companyName: item.value.companyName,
          businessType: item.value.businessType,
          percentShareholder:
            item.value.percentShareholder === null
              ? 0
              : item.value.percentShareholder
        }

        this.listAdd.push(data)
      })

      const putData = {
        delete: this.listDelete,
        securitySymbol: this.symbol,
        add: this.listAdd
      }

      const formData = new FormData()
      formData.append(
        'updateField',
        new Blob([JSON.stringify(putData)], { type: 'application/json' })
      )

      this.cpmService.updateCompanyStructure(formData).subscribe(
        success => {
          this.message = success.status
          this.message === 'OK'
            ? this.toastr.success('Successful')
            : this.toastr.error('Error ' + this.message);

          this.flagChange.emit(true)
          this.ngOnInit()
        },
        error => {
          this.message = 'บันทึกรายการไม่สำเร็จ'
          this.toastr.error('Error')
          this.ngOnInit()
        }
      )
    }
    this.editFlag = false
  }

  onChangedata() {
    const percentShareholderChange = []

    this.items.controls.map((obj, i) => {
      percentShareholderChange.push(obj.get('percentShareholder').value)
    })
    this.setInformationValue()
  }

  setInformationValue() {
    this.items.controls.map((obj, i) => {
      const percentOtherShare =
        obj.get('percentShareholder').value !== 0
          ? 100 - obj.get('percentShareholder').value
          : null
      obj.get('percentOtherShareholder').setValue(Number(percentOtherShare))
    })
  }
}

export class CompanyStructureObj {
  id: any
  companyName: any
  businessType: any
  percentShareholder: any
  percentOtherShareholder: any
  securitySymbol: any
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-structure-table/company-structure-table.component.ts